const randomWithSeed = require('random-seed')
const { USER_COLORS } = require('@constants')

module.exports = (id) => {
  const index = randomWithSeed(id).intBetween(0, USER_COLORS.length - 1)
  return USER_COLORS[index]
}
